import { styled } from "styled-components";

export const PurchasedWraaper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 18px;

  width: 250px;
`;
